// extracted by mini-css-extract-plugin
export default {"CalculationOnlineMenu":"CalculationOnlineMenu_CalculationOnlineMenu__Iq5OP","panel":"CalculationOnlineMenu_panel__xTIcL","sideBar":"CalculationOnlineMenu_sideBar__sRtZN"};